import { Line } from 'rc-progress';
import { ActivePackBalance } from 'src/types/types';

type PackUsageCardProps = {
  pack: ActivePackBalance;
  isNextToUse: boolean;
};

export const PackUsageCard = ({ pack, isNextToUse }: PackUsageCardProps) => {
  const percentage = (pack.tickets_used / pack.ticket_quota) * 100;
  const expiryDate = new Date(pack.expires_at).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });

  const getColorForPercentage = (pct: number) => {
    if (pct >= 95) return '#FF5252';
    if (pct > 80) return '#FFA726';
    if (pct >= 60) return '#42A5F5';
    return '#66BB6A';
  };

  return (
    <div
      className="mb-3 p-3 border-round"
      style={{ backgroundColor: isNextToUse ? '#fffbeb' : '#f9fafb' }}
    >
      <div className="flex align-items-center justify-content-between mb-2">
        <div>
          <span className="font-semibold">{pack.ticket_quota.toLocaleString()} tickets pack</span>
        </div>
      </div>

      <div className="text-sm mb-2">
        <div className="mb-1 text-600">
          {pack.tickets_remaining.toLocaleString()} remaining • Expires: {expiryDate}
        </div>
        <div className="text-600">
          Ticket price limit: up to ${pack.max_ticket_price.toLocaleString()}
        </div>
      </div>

      <Line
        percent={percentage}
        strokeWidth={3}
        trailColor="#f0f0f0"
        strokeColor={getColorForPercentage(percentage)}
        strokeLinecap="round"
      />
      <div className="mt-1 text-xs text-600 text-right">{Math.round(percentage)}% used</div>
    </div>
  );
};
